// extracted by mini-css-extract-plugin
export var cartIcon = "_nu-0";
export var cartIconContainer = "_nu-1";